<template>
  <div class="left-menu" :class="{ big: value }">
    <v-icon class="toggle-icon" :class="{ right: !value }" color="black" @click="$emit('input', !value)">mdi-chevron-left</v-icon>
    <ActicsLeftMenuLink class="mx-1 mt-3 mb-1" :link="{ name: 'acticsLandingPage' }">
      <div class="hvh-flex align-start py-1">
        <v-icon class="icon" color="black">mdi-home-outline</v-icon>
        <span class="uppercase font-md bold ml-1" v-if="value">Home</span>
      </div>
    </ActicsLeftMenuLink>
    <v-divider />
    <div class="hvh-flex column links-box nexa uppercase py-2">
      <ActicsLeftMenuLink class="mx-1" :link="item.link" v-for="item in $store.state.actics.menuItems" :key="item.title.join()">
        <span class="nexa-black extra-bold">{{ value ? item.title.first() : item.titleShort.first() }}</span>
        <span class="nexa-regular">{{ value ? item.title.tail().join('') : item.titleShort.tail().join('') }}</span>
      </ActicsLeftMenuLink>
    </div>

    <div class="uppercase py-2" v-if="false">
      <ActicsLeftMenuLink class="mx-1" link="/client/management">
        <div class="hvh-flex align-start py-1">
          <v-icon class="icon" color="black">mdi-cogs </v-icon>
          <span class="uppercase font-md bold ml-1" v-if="value">CLIENT MANAGEMENT</span>
        </div>
      </ActicsLeftMenuLink>
    </div>
  </div>
</template>

<script>
import iconGear from '../../../assets/images/actics/icon-gear.png';
import ActicsLeftMenuLink from './ActicsLeftMenuLink.vue';
export default {
  components: { ActicsLeftMenuLink },
  props: ['value'],
  data() {
    return {
      right: null,
      iconGear,
    }
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisActicsLeftMenu'] = this;
  },
}
</script>

<style lang="scss" scoped>
.left-menu {
  background-color: var(--bg-color-3);
  // margin-top: 80px !important;
  position: fixed;
  left: 0;
  height: 100%;
  text-align: center;
  width: 43px;
  transition: 0.4s ease-in-out;
  box-shadow: 0 1px 4px 1px rgba(6, 10, 36, 0.1), 0 5px 10px 0 rgba(6, 10, 36, 0.08);
  overflow-x: hidden;

  &.big {
    text-align: left;
    width: 280px;
  }

  .toggle-icon {
    position: absolute;
    top: 22px;
    right: -2px;

    &.right {
      transform: rotate(-180deg);
    }
  }
  .links-box {
    background-color: rgba(81, 116, 123, 0.07);
  }
  a,
  span {
    color: #04051f !important;
  }

  .icon {
    font-size: 18px;
  }
}
</style>